module.exports = __webpack_public_path__ + "img/img1-3.326c1ca0.png";